import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import {
  CustomOrderHistory,
  CustomOrderHistoryOverview,
  CustomOrderHistoryRequest,
  CustomOrderHistoryUpdate,
} from 'src/app/uig-my-account/custom-order-history/custom-order-history.models';

@Injectable()
export class CustomOrderHistoryAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService
  ) {}

  getOrders(
    formData: CustomOrderHistoryRequest
  ): Observable<CustomOrderHistoryOverview> {
    return this.http.post<CustomOrderHistoryOverview>(
      this.occEndpoints.buildUrl('customOrderHistory'),
      formData
    );
  }

  getOrder(uigOrderNumber: string): Observable<CustomOrderHistory> {
    const params = {
      orderId: uigOrderNumber,
    };
    return this.http.get<CustomOrderHistory>(
      this.occEndpoints.buildUrl('orderDetail', {urlParams: params})
    );
  }

  cancelOrder(uigOrderNumber: string): Observable<boolean> {
    const params = {
      uigOrderNumber,
    };
    return this.http.get<boolean>(
      this.occEndpoints.buildUrl(
        'customOrderHistoryCancelOrder',
          {queryParams: params}
      )
    );
  }

  cancelOrderEntry(
    uigOrderNumber: string,
    position: string
  ): Observable<boolean> {
    const params = {
      uigOrderNumber,
      position,
    };
    return this.http.get<boolean>(
      this.occEndpoints.buildUrl(
        'customOrderHistoryCancelOrderEntry',
          {queryParams: params}
      )
    );
  }

  updateOrderEntries(formData: CustomOrderHistoryUpdate): Observable<boolean> {
    return this.http.post<boolean>(
      this.occEndpoints.buildUrl(
        'customOrderHistoryUpdateOrderEntries'),
      formData
    );
  }
}
